import { Group, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { i18nKeys, useTranslation } from 'locales';
import type { AutomationLog } from 'modules/Settings/Automation/api';
import { capitalize, isString } from 'remeda';
import type { LightUser } from 'shared/hooks/use-load-light-users';

import type { AutomationModel } from '../../../../AutomationWizard';

import { ResourceAnchor } from './ResourceAnchor';

type AssignAccountManagerItemProps = {
  log: Extract<AutomationLog, { newValue: LightUser }>;
};

export const AssignAccountManagerItem = ({ log }: AssignAccountManagerItemProps) => {
  const { t } = useTranslation();

  if (isString(log.newValue)) return null;

  const modelTypeToKey: Record<AutomationModel, string> = {
    invoice: t(i18nKeys.AUTOMATION.HISTORY_PANEL.ASSIGN_ACCOUNT_MANAGER.OF_INVOICE),
    debtor: t(i18nKeys.AUTOMATION.HISTORY_PANEL.ASSIGN_ACCOUNT_MANAGER.OF_CUSTOMER),
  };

  return (
    <Stack gap={2}>
      <Group gap={4}>
        <Text fw={600} c="gray.10">
          {log.newValue.name.full}
        </Text>
        <Text>{modelTypeToKey[log.model]}</Text>
        <ResourceAnchor log={log} />
      </Group>
      <Text size="sm">{capitalize(dayjs().to(log.date))}</Text>
    </Stack>
  );
};
